// ترجماتُ المجموعة 4 — تُملأ بترجمة صفحاتها (2026-10-03). المفتاح: النصُّ العربيّ كما في tt().
const EN_B4: Record<string, string> = {
  // ── maintenance ──
  "حذف السيارة نهائياً؟": "Delete this vehicle permanently?",
  "تم حذف السيارة": "Vehicle deleted",
  "صيانة دورية": "Periodic maintenance",
  "تم تسجيل الصيانة وخصم القطع — أمر": "Maintenance recorded and parts deducted — order",
  "العدّاد": "Odometer",
  "حذف السيارة": "Delete vehicle",
  "الصيانة الدوريّة": "Periodic maintenance",
  "عرض الصيانة الدوريّة": "Show periodic maintenance",
  "عدّاد السيارة (كم)": "Vehicle odometer (km)",
  "قطع الغيار من المخزون": "Spare parts from stock",
  "إزالة": "Remove",
  "+ أضف قطعة من المخزون": "+ Add part from stock",
  "المتوفّر": "Available",
  "تُخصم من المخزون عند الحفظ، وتعود إليه إن حُذف الأمر أو أُزيلت القطعة.": "Deducted from stock on save, and returned if the order is deleted or the part removed.",
  "من المخزون (اختياري) — يُخصم ويُسجَّل تلقائياً": "From stock (optional) — deducted and logged automatically",
  "+ أضف صنفاً (زيت، فلتر...)": "+ Add item (oil, filter...)",
  "متوفر": "Available",

  // ── privacy ──
  "سياسة الخصوصية": "Privacy Policy",
  "آخر تحديث: يونيو 2026": "Last updated: June 2026",
  "تصف سياسة الخصوصية هذه كيفية قيام نظام Jisr CRM («النظام»، «نحن») بجمع واستخدام وحماية المعلومات عند استخدامك لخدماتنا، بما في ذلك التكامل مع واتساب وإنستغرام وفيسبوك لإدارة محادثات العملاء.": "This Privacy Policy describes how Jisr CRM (\"the System\", \"we\") collects, uses and protects information when you use our services, including the WhatsApp, Instagram and Facebook integrations used to manage customer conversations.",
  "المعلومات التي نجمعها": "Information We Collect",
  "معلومات التواصل: الاسم، رقم الهاتف، ومعرّف حساب إنستغرام/فيسبوك.": "Contact information: name, phone number, and Instagram/Facebook account ID.",
  "محتوى الرسائل المرسلة والمستلمة عبر واتساب وإنستغرام Direct.": "Content of messages sent and received via WhatsApp and Instagram Direct.",
  "بيانات الحجوزات والعقود والمدفوعات المرتبطة بالعميل.": "Booking, contract and payment data related to the customer.",
  "بيانات تقنية أساسية لتشغيل الخدمة (سجلات الوصول والأخطاء).": "Basic technical data needed to run the service (access and error logs).",
  "كيف نستخدم المعلومات": "How We Use Information",
  "الرد على استفسارات العملاء وإدارة المحادثات.": "Responding to customer inquiries and managing conversations.",
  "إتمام الحجوزات والعقود وخدمات التأجير.": "Completing bookings, contracts and rental services.",
  "إرسال الإشعارات والتنبيهات التشغيلية للموظفين.": "Sending operational notifications and alerts to staff.",
  "تحسين جودة الخدمة والدعم.": "Improving service quality and support.",
  "مشاركة المعلومات": "Sharing Information",
  "لا نبيع أو نؤجّر بياناتك الشخصية لأي طرف ثالث. قد تتم معالجة البيانات عبر مزوّدي الخدمات الذين نعتمد عليهم لتشغيل النظام (مثل Meta Platforms لخدمات واتساب وإنستغرام) وفقاً لسياساتهم.": "We do not sell or rent your personal data to any third party. Data may be processed by service providers we rely on to operate the System (such as Meta Platforms for WhatsApp and Instagram services) in accordance with their policies.",
  "حذف البيانات": "Data Deletion",
  "يمكنك طلب حذف بياناتك الشخصية في أي وقت عبر التواصل معنا على البريد الإلكتروني أدناه، وسنقوم بمعالجة الطلب خلال مدة معقولة.": "You can request deletion of your personal data at any time by contacting us at the email address below, and we will process the request within a reasonable time.",
  "حماية البيانات": "Data Protection",
  "نتخذ إجراءات تقنية وتنظيمية مناسبة لحماية بياناتك من الوصول غير المصرّح به أو الفقدان أو إساءة الاستخدام.": "We take appropriate technical and organizational measures to protect your data from unauthorized access, loss or misuse.",
  "التواصل معنا": "Contact Us",
  "لأي استفسار يتعلق بالخصوصية أو لطلب حذف البيانات، يرجى التواصل عبر البريد الإلكتروني:": "For any privacy question or to request data deletion, please contact us by email:",

  // ── reports ──
  "أداء الوكلاء": "Agent Performance",
  "وقت الرد، نسبة الحل، وحجم العمل": "Response time, resolution rate and workload",
  "حجم المحادثات وأوقات الذروة": "Conversation volume and peak times",
  "العملاء": "Customers",
  "العملاء الجدد والنشطين": "New and active customers",
  "مدى الالتزام بوقت الرد المستهدف": "Adherence to the target response time",
  "رضا العملاء": "Customer Satisfaction",
  "تقييمات العملاء (1–5) بعد الاستلام وإغلاق المحادثة": "Customer ratings (1–5) after pickup and conversation close",
  "استخدام القوالب": "Template Usage",
  "القوالب الأكثر والأسوأ استخداماً": "Most and least used templates",
  "البريد الإلكتروني": "Email",
  "الدور": "Role",
  "المغلقة": "Closed",
  "متوسط أول رد (دقيقة)": "Avg. first response (min)",
  "تاريخ الإنشاء": "Created at",
  "آخر رسالة": "Last message",
  "الالتزام بمستوى الخدمة": "SLA compliance",
  "التجاوزات": "Violations",
  "متوسط التقييم": "Average rating",
  "عدد التقييمات": "Ratings count",
  "نسبة الرضا (4+)": "Satisfaction rate (4+)",
  "استبيانات الاستلام": "Pickup surveys",
  "استبيانات المحادثة": "Chat surveys",
  "مرات الاستخدام": "Times used",
  "معلقة": "Pending",
  "تم إنشاء التقرير": "Report generated",
  "لا توجد بيانات للتصدير": "No data to export",
  "تم تنزيل التقرير (CSV)": "Report downloaded (CSV)",
  "التقارير والتحليلات": "Reports & Analytics",
  "تصدير بيانات الأداء والمحادثات للتحليل المتقدم": "Export performance and conversation data for advanced analysis",
  "أنواع التقارير": "Report Types",
  "إعدادات التقرير": "Report Settings",
  "إنشاء المعاينة": "Generate Preview",
  "معاينة:": "Preview:",
  "تم الإنشاء في": "Generated at",
  "تصدير CSV (يفتح في Excel)": "Export CSV (opens in Excel)",
  "لا توجد بيانات لهذه الفترة": "No data for this period",
  "اختر نوع التقرير واضغط \"إنشاء المعاينة\" لعرض البيانات": "Choose a report type and click \"Generate Preview\" to view the data",

  // ── pbx-calls ──
  "مردودة": "Answered",
  "مفقودة": "Missed",
  "صادرة": "Outgoing",
  "بتسجيل": "Recorded",
  "بملاحظة": "With note",
  "ث": "s",
  "جارٍ الجلب من البدالة…": "Fetching from PBX…",
  "▶ تشغيل التسجيل": "▶ Play recording",
  "خلاصة المراجعة: ماذا طلب العميل؟ هل الرد كان كافياً؟ ما المطلوب بعدها؟": "Review summary: what did the customer ask? Was the answer sufficient? What's the next step?",
  "مسح الملاحظة": "Clear note",
  "＋ إضافة ملاحظة مراجعة": "＋ Add review note",
  "بحث برقم المتصل أو اسم العميل أو اسم الموظف…": "Search by caller number, customer or employee name…",
  "جاري تحميل المكالمات…": "Loading calls…",
  "لا توجد مكالمات": "No calls",
  "تظهر هنا مكالمات البدالة فور ورودها — إن كانت البدالة مربوطة من لوحة الماستر": "PBX calls appear here as they come in — if the PBX is connected from the master panel",
  "عرض كل مكالمات هذا الرقم": "Show all calls from this number",
  "ملف العميل ←": "Customer profile →",
  "رد عليها:": "Answered by:",
  "اتصل:": "Called by:",
  "المدة:": "Duration:",
  "عرض مكالمات أقدم": "Show older calls",

  // ── contracts-finance ──
  "مغلق": "Closed",
  "متأخر الإرجاع": "Overdue return",
  "ينتهي قريباً": "Ending soon",
  "قادم": "Upcoming",
  "تعذر تجهيز العميل": "Could not prepare the customer",
  "تعذر فتح المحادثة": "Could not open the conversation",
  "لا تملك صلاحية عرض هذه الصفحة.": "You don't have permission to view this page.",
  "لوحة التحصيل — عقود التأجير": "Collections Board — Rental Contracts",
  "وضع التحصيل والعقود اللي تحتاج إجراء اليوم — بنظرة وحدة": "Collection status and contracts needing action today — at a glance",
  "📈 الاتجاه الشهري": "📈 Monthly trend",
  "عدد العقود": "Contracts",
  "إجمالي المتبقّي": "Total outstanding",
  "الصافي (مقبوض − صرف)": "Net (received − expenses)",
  "٪": "%",
  "يحتاج انتباه:": "Needs attention:",
  "نشطة الآن": "Active now",
  "تنتهي اليوم": "Ending today",
  "خلال ٣ أيام": "Within 3 days",
  "متأخرة الإرجاع": "Overdue return",
  "عليها متبقٍّ": "With balance due",
  "مدفوعة كاملاً": "Fully paid",
  "المفوتر مقابل المقبوض — آخر ١٢ شهراً بحسب شهر بداية العقد (د.ك)": "Billed vs. received — last 12 months by contract start month (KWD)",
  "المفوتر": "Billed",
  "المقبوض": "Received",
  "🤖 مساعد التحصيل": "🤖 Collections assistant",
  "🔄 حدّث": "🔄 Refresh",
  "✨ من أتصل اليوم؟": "✨ Who should I call today?",
  "يقرأ Jisr AI وضع التحصيل الحالي ويحدد لك: من تطارد اليوم، وأي العقود الأخطر، واتجاه الإيراد.": "Jisr AI reads the current collection status and tells you who to chase today, which contracts are most at risk, and the revenue trend.",
  "بحث بالاسم / الرقم المدني / رقم العقد / السيارة... (Enter)": "Search by name / civil ID / contract no. / vehicle... (Enter)",
  "مفوتر:": "Billed:",
  "مقبوض:": "Received:",
  "صرف:": "Expenses:",
  "صافي:": "Net:",
  "{n}٪ محصّل": "{n}% collected",
  "متبقّي:": "Outstanding:",
  "مدني:": "Civil ID:",
  "خصم:": "Discount:",
  "تلفيات:": "Damages:",
  "تأخير:": "Late fee:",
  "زيادة عداد:": "Extra km:",
  "فتح محادثة العميل في جسر": "Open the customer's conversation in Jisr",
  "تفاصيل الرسوم (المفوتر)": "Charge details (billed)",
  "قيمة الإيجار": "Rental value",
  "خدمات السائق": "Driver services",
  "زيادة في العداد": "Extra kilometers",
  "تأخير في التسليم": "Late return",
  "تلفيات": "Damages",
  "مبلغ إضافي على العقد": "Additional contract amount",
  "الإجمالي المفوتر": "Total billed",
  "تفاصيل المصروفات (الصرف)": "Expense details",
  "لا توجد مصروفات على هذا العقد": "No expenses on this contract",
  "نوع": "Type",
  "ملاحظات العقد:": "Contract notes:",
  "يُعرض 500 عقد — ضيّق النطاق أو ابحث (الإجماليات أعلاه تشمل كل النتائج).": "Showing 500 contracts — narrow the range or search (the totals above include all results).",
  "💬 محادثة": "💬 Conversation",
  "الإرسال من واتساب:": "Send from WhatsApp:",
  "لا توجد حسابات واتساب مفعّلة": "No active WhatsApp accounts",
  "حساب": "Account",
  "فتح المحادثة ←": "Open conversation →",
  "نص تذكير جاهز (الصقه في المحادثة):": "Ready reminder text (paste it into the conversation):",
  "✓ نُسخ": "✓ Copied",
  "📋 نسخ": "📋 Copy",

  // ── check-in ──
  "جهازك لا يدعم تحديد الموقع": "Your device doesn't support location",
  "تم رفض إذن الموقع — فعّله من الإعدادات.": "Location permission denied — enable it in settings.",
  "تعذّر تحديد الموقع — تأكد من تشغيل GPS.": "Couldn't get your location — make sure GPS is on.",
  "معتمد": "Approved",
  "{t} ص": "{t} AM",
  "{t} م": "{t} PM",
  "تعذّر فتح الكاميرا": "Couldn't open the camera",
  "فعّل إذن الكاميرا للتطبيق من الإعدادات ثم حاول مجدداً.": "Allow camera access for the app in settings, then try again.",
  "حضورُك مسجَّلٌ فعلاً": "Your check-in is already recorded",
  "لا حاجةَ لإعادة التسجيل.": "No need to check in again.",
  "تعذّر": "Failed",
  "تم تسجيل الحضور ✅": "Checked in ✅",
  "تم الانصراف ✅": "Checked out ✅",
  "لم نتأكّد": "Not confirmed",
  "تعذّر التقاط الصورة": "Couldn't capture the photo",
  "تعذّر رفع الصورة": "Couldn't upload the photo",
  "بصمتُك السابقةُ أُغلقت": "Your previous punch was closed",
  "اضغط مرّةً أخرى لبدء مناوبةٍ جديدة.": "Press again to start a new shift.",
  "هذه إعادةُ إرسالٍ للمحاولة نفسِها — لم تُسجَّل بصمةٌ ثانية.": "This was a resend of the same attempt — no second punch was recorded.",
  "تم التسجيل بانتظار مراجعة الإدارة": "Recorded, pending management review",
  "انصرافُك مسجَّلٌ فعلاً": "Your check-out is already recorded",
  "المحفوظ: {d} — لم يُغيَّر وقتُ الخروج.": "Saved: {d} — the check-out time was not changed.",
  "لم يُسجَّل الحضور بعد": "Not checked in yet",
  "على رأس العمل": "On duty",
  "انتهى دوام اليوم": "Today's shift ended",
  "اكتمل تسجيل اليوم": "Today's attendance complete",
  "تسجيل الانصراف": "Check out",
  "تسجيل الحضور بالصورة": "Check in with photo",
  "دوامك يبدأ": "Your shift starts at",
  "حسابك غير مرتبط بملف حضور. راجع الإدارة لربط حسابك في «الحضور والرواتب».": "Your account isn't linked to an attendance profile. Ask management to link it under \"Attendance & Payroll\".",
  "تأخير {n} د": "{n} min late",
  "توقيت الكويت": "Kuwait time",
  "الدخول": "In",
  "الخروج": "Out",
  "ساعات العمل": "Work hours",
  "يلزم تفعيل GPS والكاميرا والتواجد داخل نطاق الفرع لتسجيل الحضور.": "GPS and camera must be enabled and you must be within the branch zone to check in.",
  "ملخّص الشهر": "Monthly summary",
  "أيام الحضور": "Days present",
  "أيام الغياب": "Days absent",
  "أيام التأخير": "Days late",
  "تعذّرت قراءة الاستئذان المعتمَد — الغيابُ والتأخيرُ لم يُحتسبا. راجع الإدارة.": "Couldn't read approved leave — absences and lateness were not calculated. Contact management.",
  "كشوف الرواتب المعتمدة": "Approved payslips",
  "شهرٌ تقويميّ — قد تختلف عنه فترةُ الراتب. الراتبُ يُقرأ من الكشف بحدود فترته.": "Calendar month — the payroll period may differ. Pay is read from the payslip and its own period.",
  "تغيّرت فترةُ هذا الشهر بين قراءتين — أعد التحميل قبل أيّ فعل": "This month's period changed between two reads — reload before any action",
  "ردُّ الرواتب بلا هويّةِ فترةٍ مقروءة — حدّث الصفحة": "Payroll response has no readable period identity — refresh the page",
  "تغيّرت فترةُ هذا الشهر — حدّث الصفحة قبل أيّ فعل": "This month's period changed — refresh the page before any action",
  "تغيّرت صفوفُ الشهر أثناء التأكيد — راجعها ثمّ أعِد": "The month's rows changed during confirmation — review them and try again",
  "الفترة (شاملة)": "Period (inclusive)",
  "لا توجد كشوف معتمدة بعد — تظهر بعد اعتماد الراتب نهاية الشهر.": "No approved payslips yet — they appear once salary is approved at month end.",
  "أساسي": "Base",
  "مكافأة": "Bonus",
  "خصومات": "Deductions",
  "سجلّ الأيام السابقة": "Previous days",
  "آخر {n} أيام": "Last {n} days",
  "لا توجد سجلات بعد": "No records yet",
  "راتبي": "My salary",
  "الراتب التعاقدي من نظام ERP": "Contract salary from the ERP system",
  "إخفاء / إظهار المبالغ": "Hide / show amounts",
  "حسابك غير مربوط ببيانات راتب في نظام ERP. تواصل مع الإدارة لربط رقمك الوظيفي أو المدني.": "Your account isn't linked to salary data in the ERP system. Contact management to link your employee or civil ID.",
  "الراتب الأساسي": "Base salary",
  "إجمالي البدلات": "Total allowances",
  "بند": "Item",
  "صافي الراتب": "Net salary",
  "طريقة الصرف": "Payment method",
  "حساب الصرف": "Payment account",
  "جسر · Jisr": "Jisr",
  "إدارة الحضور والرواتب": "Attendance & payroll management",
  "ثبّت وجهك داخل الإطار ثم اضغط التقاط": "Keep your face inside the frame, then press capture",
  "التقاط وتسجيل": "Capture & record",
  "قيد الانتظار": "Pending",
  "مسحوب": "Withdrawn",
  "تعذّر الاتصال": "Connection failed",
  "أُرسل الطلب": "Request sent",
  "سيصل المشرفَ أو المديرَ للاعتماد.": "It will go to a supervisor or manager for approval.",
  "لم يُقبل الطلب": "Request not accepted",
  "نتيجةُ الإرسال لم تُحسَم بعد": "Submission result not settled yet",
  "لا أثرَ له في طلباتك الآن — وقد يصل بعد لحظات. أعد القراءة قبل أن تُرسل ثانيةً.": "It isn't in your requests yet — it may arrive in a moment. Reload before sending again.",
  "نتيجةُ الإرسال غيرُ مؤكَّدة": "Submission result uncertain",
  "راجع القائمة أدناه قبل إعادة الإرسال.": "Check the list below before resending.",
  "سُحب الطلب": "Request withdrawn",
  "تعذّر سحب الطلب": "Couldn't withdraw the request",
  "الاستئذان": "Leave requests",
  "{n} طلبٌ قيد الانتظار": "{n} pending request(s)",
  "قدّم طلباً واقرأ قرارَه هنا": "Submit a request and see its decision here",
  "إغلاق النموذج": "Close form",
  "طلب استئذان": "Request leave",
  "ساعات": "Hours",
  "أيام": "Days",
  "يوم الاستئذان": "Leave day",
  "بداية المدّة": "Start time",
  "نهاية المدّة": "End time",
  "من يوم": "From day",
  "أوّل يوم": "First day",
  "إلى يوم": "To day",
  "آخر يوم": "Last day",
  "مراجعة طبيّة…": "Medical appointment…",
  "سبب الاستئذان": "Leave reason",
  "مدّةٌ تعبر منتصف الليل — ستُسجَّل إلى {d}.": "The period crosses midnight — it will be recorded until {d}.",
  "اكتب سببَ الاستئذان.": "Enter the leave reason.",
  "جارٍ الإرسال…": "Sending…",
  "إرسال الطلب": "Send request",
  "يقرّره مشرفٌ أو مديرٌ، ويصلك القرارُ هنا. والطلبُ لا يُحذف — يبقى بقراره في القائمة أدناه.": "A supervisor or manager decides it, and the decision shows here. Requests aren't deleted — they stay in the list below with their decision.",
  "تعذّرت قراءةُ طلباتك": "Couldn't read your requests",
  "طلبٌ مطابقٌ موجودٌ في قائمتك": "A matching request exists in your list",
  "ضاع ردُّ الإرسال، ثمّ تعذّرت قراءةُ طلباتك — فلا يُعرف أحُفظ أم لا. أعد القراءة قبل أن تُرسل ثانيةً.": "The submission response was lost and your requests couldn't be read — so it's unknown whether it was saved. Reload before sending again.",
  "ضاع ردُّ الإرسال، ولا أثرَ للطلب في قائمتك حتى الآن — وقد يصل بعد لحظات إن كان الإرسالُ ما زال جارياً. أعد القراءة بعد قليل قبل أن تُرسل ثانيةً.": "The submission response was lost and the request isn't in your list yet — it may arrive shortly if the submission is still in progress. Reload in a moment before sending again.",
  "ضاع ردُّ الإرسال، ويوجد في طلباتك طلبٌ مطابقٌ للمدّة والسبب حالتُه «{s}» — ووجودُه لا يُثبت أنّ إرسالَك هذا هو ما أنشأه: قد يكون طلباً سابقاً أو أنشأته جلسةٌ أخرى. راجع القائمة أدناه، والمكتوبُ باقٍ حتى تقرّر.": "The submission response was lost, and your requests contain one matching the period and reason with status \"{s}\" — that doesn't prove this submission created it: it may be an earlier request or one created by another session. Check the list below; your input is kept until you decide.",
  "ضاع ردُّ الإرسال، وقائمتُك بلغت حدَّ {n} طلباً فقد يكون خارجَها. راجع القائمة قبل إعادة الإرسال.": "The submission response was lost, and your list reached the {n}-request limit, so it may be outside it. Check the list before resending.",
  "جارٍ القراءة…": "Reading…",
  "أعد قراءة طلباتي": "Reload my requests",
  "إخفاء": "Hide",
  "تعذّر تحميل طلباتك": "Couldn't load your requests",
  "لا طلباتٍ بعد.": "No requests yet.",
  "اعتمده": "Approved by",
  "رفضه": "Rejected by",
  "سحب الطلب": "Withdraw request",
  "معروضٌ أحدثُ {n} طلباً — الأقدمُ منها غيرُ ظاهرٍ هنا.": "Showing the latest {n} requests — older ones aren't shown here.",
  // أخطاء `buildLeaveInterval` (lib/attendance-daily.ts) تُعرض في check-in عبر tt(ivError)
  "اكتب الوقت بصيغة 08:30": "Enter the time as 08:30",
  "حدّد بدايةَ المدّة ونهايتَها": "Set the start and end of the period",
  "نهايةُ المدّة قبل بدايتها أو تساويها": "The end of the period is before or equal to its start",
};
export default EN_B4;
